<div class="chart-selection-container">
  <div class="charts-grid">
    @for (chart of filteredCharts; track chart.id) {
      <app-card
        [cardData]="{
          id: chart.id.toString(),
          title: getChartTitle(chart),
          image: 'assets/img/graph/' + chart.name + '.png',
          description: getChartDescription(chart),
          tags: getChartTags(chart)
        }"
        (cardSelected)="onChartSelected(chart)"
        [attr.data-tracking-id]="'chart-card-' + chart.name"
      ></app-card>
    }
  </div>

  @if (filteredCharts.length === 0) {
    <div class="no-results">
      <p>
        {{ "analytics.noResultsFound" | translate: { searchTerm: searchTerm } }}
      </p>
    </div>
  }
</div>
